export enum Environments {
    dev = 0,
    ci = 1,
    ppe = 2,
    production = 3, // todo, better rename to adfproduction
    fairfax = 4,    // adf
    mooncake = 5,   // adf
    a365dev = 6,    // a365 dev environment public
    a365ci = 7,     // a365 CICD environment public
    a365stg = 8,
    a365prod = 9,   // a365 PROD environment public
    sparkoncosmos = 10,
    adfusnat = 11,
    a365mooncake = 12, // a365 PROD environment - Mooncake (There's no dev/CI/PPE in MC)
    adfussec = 13,
    a365fairfax = 14,  // a365 PROD environment - Fairfax (There's no dev/CI/PPE in FF)
    a365usnat = 15,
    a365ussec = 16,
    a365df = 17,     // a365 Dogfood enviroment
    adfbleu = 18,      // Bleu environment (France)
    a365bleu = 19,   // a365 Bleu environment (France)
    adfdelos = 20,     // Delos environment (Germany)
    a365delos = 21     // a365 Delos environment (Germany)
}
